// ============================================================================
// PORTAL COMPLETAR CADASTRO REPOSITORY
// ARQUIVO: src/pages/portal/PortalCompletarCadastroRepository.js
// RESPONSABILIDADE: Isolar todas as chamadas Firestore do PortalCompletarCadastro.
// ============================================================================

import {
  collection, doc, getDoc, getDocs, query, serverTimestamp, where
} from 'firebase/firestore';
import { db } from '../../shared/api/firebase/config';
import { saveClientWithCpfIndex } from '../../services/cpfIndexService';

export const fetchClientById = async (appId, clientId) => {
  const docRef = doc(db, 'artifacts', appId, 'public', 'data', 'clients', clientId);
  const snap = await getDoc(docRef);
  if (snap.exists() && snap.data()?.isDeleted !== true) {
    return { id: snap.id, ...snap.data() };
  }
  return null;
};

export const findClientsByEmail = async (appId, email) => {
  const ref = collection(db, 'artifacts', appId, 'public', 'data', 'clients');
  const tryEmails = [email];
  const lower = email.toLowerCase();
  if (lower !== email) tryEmails.push(lower);

  const hits = [];
  for (const probe of tryEmails) {
    const snap = await getDocs(query(ref, where('contact.email', '==', probe)));
    snap.docs.forEach((d) => {
      const data = d.data() || {};
      if (data.isDeleted === true) return;
      if (!hits.find((h) => h.id === d.id)) {
        hits.push({ id: d.id, ...data });
      }
    });
  }
  return hits;
};

export const checkCpfConflict = async (appId, cpf, safeClientId) => {
  const cpfSnap = await getDocs(
    query(collection(db, 'artifacts', appId, 'public', 'data', 'clients'),
      where('qualification.physical.cpf', '==', cpf))
  );
  const conflict = cpfSnap.docs.find(
    (d) => d.id !== safeClientId && d.data()?.isDeleted !== true
  );
  return conflict ? conflict.id : null;
};

export const savePortalClient = async (appId, safeClientId, payload, cpf) => {
  const docRef = doc(db, 'artifacts', appId, 'public', 'data', 'clients', safeClientId);
  const portalResult = await saveClientWithCpfIndex(docRef, payload, cpf, { existingClientId: safeClientId });
  return portalResult;
};
